export default __webpack_public_path__ + "static/media/user.17e3d377.png";